import { render, staticRenderFns } from "./registerPersonal.vue?vue&type=template&id=c66121e0&scoped=true&"
import script from "./registerPersonal.vue?vue&type=script&lang=js&"
export * from "./registerPersonal.vue?vue&type=script&lang=js&"
import style0 from "./registerPersonal.vue?vue&type=style&index=0&id=c66121e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66121e0",
  null
  
)

export default component.exports